/**
 * Configuration for AI request retry behavior
 */
export const AI_RETRY_CONFIG = {
  /** Maximum number of retry attempts for failed AI requests */
  MAX_RETRIES: 2,

  /**
   * Delay in milliseconds before each retry attempt
   * @param attempt - Current retry attempt (1-based)
   * @returns Delay in milliseconds
   */
  getRetryDelay: (attempt: number): number => 1000 * attempt, // 1s for first retry, 2s for second

  /**
   * Types of errors that are eligible for retry
   */
  RETRYABLE_ERROR_TYPES: {
    NETWORK: 'network',
    TIMEOUT: 'timeout',
    SERVER: 'server',
    RATE_LIMIT: 'rateLimit',
  },
};

/**
 * Interface for AbortController state
 */
export interface AbortControllerState {
  /** The AbortController instance */
  controller: AbortController | null;
  /** Sets a new AbortController */
  setController: (controller: AbortController | null) => void;
  /** Aborts any existing controller and creates a new one */
  getNewController: () => AbortController;
  /** Aborts any existing controller */
  abortCurrentController: () => void;
}

/**
 * Interface for retry state
 */
export interface RetryState {
  /** Whether a silent retry is in progress */
  isSilentlyRetrying: boolean;
  /** Current retry attempt number (0-based) */
  retryAttempt: number;
  /** Whether any retry is in progress (tracks between renders) */
  isRetrying: boolean;
  /** Component is mounted (for async operations) */
  isMounted: boolean;
}
